const React = require('react');
const { createElement: h, useEffect } = React;
require('./ConfirmDialog.css');

function ConfirmDialog(props) {
  var title = props.title || 'Are you sure?';
  var message = props.message || '';
  var confirmLabel = props.confirmLabel || 'Delete';
  var cancelLabel = props.cancelLabel || 'Cancel';
  var onConfirm = props.onConfirm || function() {};
  var onCancel = props.onCancel || function() {};
  var danger = props.danger !== false;
  var hideCancel = props.hideCancel === true;
  // Optional inline width/size override for the dialog box (e.g. a wider notice).
  var boxStyle = props.boxStyle || null;

  useEffect(function() {
    function onKeyDown(e) {
      if (e.key === 'Escape') onCancel();
      if (e.key === 'Enter') onConfirm();
    }
    document.addEventListener('keydown', onKeyDown);
    return function() { document.removeEventListener('keydown', onKeyDown); };
  }, []);

  return h('div', { className: 'cdialog-overlay', onMouseDown: onCancel },
    h('div', {
      className: 'cdialog-box',
      style: boxStyle,
      onMouseDown: function(e) { e.stopPropagation(); }
    },
      h('div', { className: 'cdialog-icon' + (danger ? ' cdialog-icon--danger' : '') },
        h('svg', { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
          danger
            ? h('path', { d: 'M3 6h18M8 6V4h8v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6' })
            : h('path', { d: 'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' })
        )
      ),
      h('div', { className: 'cdialog-title' }, title),
      message ? h('div', { className: 'cdialog-message' }, message) : null,
      h('div', { className: 'cdialog-actions' },
        hideCancel ? null : h('button', { className: 'cdialog-btn cdialog-btn-cancel', onClick: onCancel }, cancelLabel),
        h('button', { className: 'cdialog-btn' + (danger ? ' cdialog-btn-danger' : ' cdialog-btn-confirm'), onClick: onConfirm, autoFocus: true }, confirmLabel)
      )
    )
  );
}

module.exports = ConfirmDialog;
